// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');
//@ constants
const actionTypes =  require('constants/contactCenter/actionTypes');
const {
    FIRST_STEP
} = require('constants/index');
const contactTypes = require('constants/contactCenter/updateClientContactTime');

const updateContactTimeRequest = () => ({
    type: actionTypes.UPDATE_CONTACT_TIME_IN_PROGRESS
});

const updateContactTimeRequestSuccess = () => ({
    type: actionTypes.UPDATE_CONTACT_TIME_SUCCESS,
});

const updateContactTimetRequestFailure = (error) => ({
    type: actionTypes.UPDATE_CONTACT_TIME_ERROR,
    payload: {
        error
    }
});

const onResetUpdateClientContactTimeData = () => ({
    type: actionTypes.UPDATE_CONTACT_TIME_RESET,
});

const setVisibleStep = (step) => {
    return {
        type: actionTypes.UPDATE_CONTACT_TIME_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

const validateUIStep = step => ({
    type: actionTypes.UPDATE_CONTACT_TIME_VALIDATE_UI_STEP,
    payload: {
        step
    }
});

const setFromTime = fromTime => ({
    type:actionTypes.UPDATE_CONTACT_TIME_FROM_TIME,
    payload: {
        fromTime
    }
});

const setToTime = toTime => ({
    type: actionTypes.UPDATE_CONTACT_TIME_TO_TIME,
    payload: {
        toTime
    }
});

const validateSetStep = (step) => (dispatch, getState) => {

    const valid = getState().updateClientContactTime.getIn(['steps', step-1, 'valid']);
    let visibleStep = getState().updateClientContactTime.get('visibleStep');
    if(valid){
        visibleStep++;
    }
    dispatch(setVisibleStep(visibleStep));
};

const validateStep = step => dispatch => {
    dispatch(validateUIStep(step));
    dispatch(validateSetStep(step));
};

const saveClientContactTime = (contactType) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immUpdateClientContactTime = getState().updateClientContactTime;
        const initialContactTime = immUpdateClientContactTime.getIn(['steps', FIRST_STEP, 'initialContactTime']);
        const finalContactTime = immUpdateClientContactTime.getIn(['steps', FIRST_STEP, 'finalContactTime']);

        const params = {
            query: {
                "horaDesde": initialContactTime,
                "horaHasta": finalContactTime,
                "tipoContacto": contactTypes[contactType],
                "tokenFirma": dataToken
            }
        };

        dispatch(updateContactTimeRequest());

        return APIPost({
            dispatch,
            endpoint: 'updateClientContactTime',
            params
        })
            .then((response) => dispatch(updateContactTimeRequestSuccess(response)))
            .catch((response) => dispatch(updateContactTimetRequestFailure(response.error)))
    }

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
}

module.exports = {
    setVisibleStep,
    validateStep,
    validateUIStep,
    setFromTime,
    setToTime,
    saveClientContactTime,
    onResetUpdateClientContactTimeData
}
